import { type FunctionComponent } from 'react';
import { MAX_PAGE_WIDTH } from '../../../../constants/breakpoints';
import { PROJECT_TOOL_VIDEO, PROMO_VIDEO_DESCRIPTION, PROMO_VIDEO_TITLE } from '../../../../constants/project/about-page';
import { isChromatic } from '../../../../utils/dom/chromatic.utils';
import { EmbeddedVideo } from '../../../common-components/embedded-video/embedded-video.component';
import { ContentCardDetails } from '../../../showroom-components/showroom-experience/content-card-details/content-card-details.component';

export const AboutPagePromoVideo: FunctionComponent = () => {
	return (
		<section className="flex flex-column items-center w-100 ph3 mb6">
			<div className="flex flex-column flex-row-reverse-ns gc4 items-center w-100 z-2" style={{ maxWidth: MAX_PAGE_WIDTH }}>
				<div className="br2 shadow-1 overflow-hidden w-100 mb3 mb0-ns" style={{ maxWidth: 720, minWidth: '50%' }}>
					<EmbeddedVideo video={PROJECT_TOOL_VIDEO} shouldLoadEagerly={isChromatic()} />
				</div>
				<ContentCardDetails title={PROMO_VIDEO_TITLE} description={PROMO_VIDEO_DESCRIPTION} />
			</div>
		</section>
	);
};
